import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=6fc42d04&scoped=true&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=6fc42d04&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc42d04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
